import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="bottom-center"
      offset={100}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#F6F8FB] group-[.toaster]:text-[#0B1620] group-[.toaster]:border group-[.toaster]:border-[#E4E8EF] group-[.toaster]:rounded-2xl group-[.toaster]:shadow-[0_20px_50px_-20px_rgba(11,22,32,0.25)] group-[.toaster]:px-4 group-[.toaster]:py-3 group-[.toaster]:font-medium",
          description: "group-[.toast]:text-[#5B6675]",
          actionButton:
            "group-[.toast]:bg-[#0B4F3F] group-[.toast]:text-white group-[.toast]:rounded-full",
          cancelButton:
            "group-[.toast]:bg-[#EFF2F7] group-[.toast]:text-[#0B1620] group-[.toast]:rounded-full",
          success: "group-[.toaster]:!border-[#0B4F3F]/25",
          error: "group-[.toaster]:!border-[#DC2626]/30",
          info: "group-[.toaster]:!border-[#0B4F3F]/25",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
